import * as $$Array from "bs-platform/lib/es6/array.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as Stream from "bs-platform/lib/es6/stream.js";
import * as Ndarray from "./ndarray.bs.js";
import * as Caml_array from "bs-platform/lib/es6/caml_array.js";
import * as Caml_int32 from "bs-platform/lib/es6/caml_int32.js";
import * as Pervasives from "bs-platform/lib/es6/pervasives.js";
import * as Caml_builtin_exceptions from "bs-platform/lib/es6/caml_builtin_exceptions.js";

function kind_size_in_bytes(param) {
  switch (param) {
    case
    /* Int16_signed */
    4:
    case
    /* Int16_unsigned */
    5:
    case
    /* Int */
    8:
    case
    /* Nativeint */
    9:
      return 2;

    case
    /* Float32 */
    0:
    case
    /* Int32 */
    6:
    case
    /* Complex32 */
    10:
      return 4;

    case
    /* Float64 */
    1:
    case
    /* Int64 */
    7:
    case
    /* Complex64 */
    11:
      return 8;

    case
    /* Int8_signed */
    2:
    case
    /* Int8_unsigned */
    3:
    case
    /* Char */
    12:
      return 1;
  }
}

function create(kind, layout, dims) {
  if (layout) {
    return Pervasives.failwith("Bigarray_bs.create: fortran layout unsupported");
  } else {
    return Ndarray.of_kind(kind, dims);
  }
}

function nth_dim(t, i) {
  return Caml_array.caml_array_get(Ndarray.shape(t), i);
}

function layout(param) {
  return Pervasives.failwith("nyi");
}

function change_layout(param) {
  return Pervasives.failwith("nyi");
}

function size_in_bytes(t) {
  return Caml_int32.imul(Ndarray.elem_size_in_bytes(t), Ndarray.size(t));
}

function sub_left(param) {
  return Pervasives.failwith("Bigarray_bs.sub_left: unsupported");
}

function sub_right(param) {
  return Pervasives.failwith("Bigarray_bs.sub_right: unsupported");
}

function slice_right(param) {
  return Pervasives.failwith("Bigarray_bs.slice_right: unsupported");
}

function map_file(param) {
  return Pervasives.failwith("Bigarray_bs.map_file: unsupported");
}

function fold(init, f, data) {
  var num_dims = Ndarray.shape(data).length;

  var folder = function folder(accum, indices) {
    var match = num_dims === indices.length;

    if (match) {
      return Curry._3(f, indices, accum, Curry._2(Ndarray.get, data, indices));
    } else {
      var nth_dim = Caml_array.caml_array_get(Ndarray.shape(data), indices.length);
      var stream = Stream.from(function (x) {
        var match = x < nth_dim;

        if (match) {
          return x;
        }
      });
      var _accum = accum;

      while (true) {
        var accum$1 = _accum;
        var i;

        try {
          i = Stream.next(stream);
        } catch (exn) {
          if (exn === Stream.Failure) {
            return accum$1;
          } else {
            throw exn;
          }
        }

        _accum = folder(accum$1, $$Array.append(indices,
        /* array */
        [i]));
        continue;
      }

      ;
    }
  };

  return folder(init,
  /* array */
  []);
}

function iter(data, f) {
  return fold(
  /* () */
  0, function (indices, _acc, v) {
    return Curry._2(f, indices, v);
  }, data);
}

function fill(t, v) {
  return iter(t, function (indices, _v) {
    return Curry._3(Ndarray.set, t, indices, v);
  });
}

function blit(t, t$prime) {
  return iter(t, function (indices, v) {
    return Curry._3(Ndarray.set, t$prime, indices, v);
  });
}

function read_t(param, param$1, param$2, x) {
  return Ndarray.fromJs(x);
}

function write_t(param, param$1, param$2, x) {
  return Ndarray.toJs(x);
}

var indices =
/* array */
[0];

function create$1(kind, layout) {
  return create(kind, layout,
  /* array */
  [1]);
}

function get(t) {
  return Curry._2(Ndarray.get, t, indices);
}

function set(t, v) {
  return Curry._3(Ndarray.set, t, indices, v);
}

function of_value(k, l, v) {
  var g = create$1(k, l);

  Curry._3(Ndarray.set, g, indices, v);

  return g;
}

function create$2(kind, layout, len) {
  return create(kind, layout,
  /* array */
  [len]);
}

function dim(g) {
  return Caml_array.caml_array_get(Ndarray.shape(g), 0);
}

function get$1(t, i) {
  return Curry._2(Ndarray.get, t,
  /* array */
  [i]);
}

function set$1(t, i, x) {
  return Curry._3(Ndarray.set, t,
  /* array */
  [i], x);
}

function slice(t, i) {
  return Curry._2(Ndarray.pick, t,
  /* array */
  [i]);
}

function of_array(kind, layout, arr) {
  var g = create$2(kind, layout, arr.length);
  iter(g, function (indices, _v) {
    return set$1(g, Caml_array.caml_array_get(indices, 0), Caml_array.caml_array_get(arr, Caml_array.caml_array_get(indices, 0)));
  });
  return g;
}

function map_file$1(file_desc, pos, kind, layout, b, i) {
  return Curry._5(Pervasives.failwith("Bigarray_bs.map_file: unsupported"), pos, kind, layout, b,
  /* array */
  [i]);
}

function create$3(k, l, i, j) {
  return create(k, l,
  /* array */
  [i, j]);
}

function dim1(t) {
  return Caml_array.caml_array_get(Ndarray.shape(t), 0);
}

function dim2(t) {
  return Caml_array.caml_array_get(Ndarray.shape(t), 1);
}

function get$2(t, i, j) {
  return Curry._2(Ndarray.get, t,
  /* array */
  [i, j]);
}

function set$2(t, i, j) {
  return Curry._2(Ndarray.set, t,
  /* array */
  [i, j]);
}

function slice_left(t, i) {
  return Curry._2(Ndarray.pick, t,
  /* array */
  [i]);
}

function slice_right$1(t, i) {
  return Curry._1(Pervasives.failwith("Bigarray_bs.slice_right: unsupported"),
  /* array */
  [i]);
}

function of_array$1(kind, layout, arr) {
  var g = create$3(kind, layout, arr.length, Caml_array.caml_array_get(arr, 0).length);
  iter(g, function (indices, _v) {
    return Curry._1(set$2(g, Caml_array.caml_array_get(indices, 0), Caml_array.caml_array_get(indices, 1)), Caml_array.caml_array_get(Caml_array.caml_array_get(arr, Caml_array.caml_array_get(indices, 0)), Caml_array.caml_array_get(indices, 1)));
  });
  return g;
}

function map_file$2(file_desc, pos, kind, layout, b, i, j) {
  return Curry._5(Pervasives.failwith("Bigarray_bs.map_file: unsupported"), pos, kind, layout, b,
  /* array */
  [i, j]);
}

function create$4(k, l, x, y, z) {
  return create(k, l,
  /* array */
  [x, y, z]);
}

function dim1$1(t) {
  return Caml_array.caml_array_get(Ndarray.shape(t), 0);
}

function dim2$1(t) {
  return Caml_array.caml_array_get(Ndarray.shape(t), 1);
}

function dim3(t) {
  return Caml_array.caml_array_get(Ndarray.shape(t), 2);
}

function get$3(t, i, j, k) {
  return Curry._2(Ndarray.get, t,
  /* array */
  [i, j, k]);
}

function set$3(t, i, j, k, v) {
  return Curry._3(Ndarray.set, t,
  /* array */
  [i, j, k], v);
}

function slice_left_1(t, i, j) {
  return Curry._2(Ndarray.pick, t,
  /* array */
  [i, j]);
}

function slice_right_1(t, i, j) {
  return Curry._1(Pervasives.failwith("Bigarray_bs.slice_right: unsupported"),
  /* array */
  [i, j]);
}

function slice_left_2(t, i) {
  return Curry._2(Ndarray.pick, t,
  /* array */
  [i]);
}

function slice_right_2(t, i) {
  return Curry._1(Pervasives.failwith("Bigarray_bs.slice_right: unsupported"),
  /* array */
  [i]);
}

function of_array$2(kind, layout, arr) {
  var dim1 = arr.length;
  var dim2 = Caml_array.caml_array_get(arr, 0).length;
  var dim3 = Caml_array.caml_array_get(Caml_array.caml_array_get(arr, 0), 0).length;
  var g = create$4(kind, layout, dim1, dim2, dim3);
  iter(g, function (indices, _v) {
    var i = Caml_array.caml_array_get(indices, 0);
    var j = Caml_array.caml_array_get(indices, 1);
    var k = Caml_array.caml_array_get(indices, 2);
    return set$3(g, i, j, k, Caml_array.caml_array_get(Caml_array.caml_array_get(Caml_array.caml_array_get(arr, i), j), k));
  });
  return g;
}

function map_file$3(file_desc, pos, kind, layout, b, i, j, k) {
  return Curry._5(Pervasives.failwith("Bigarray_bs.map_file: unsupported"), pos, kind, layout, b,
  /* array */
  [i, j, k]);
}

function genarray_of_array0(t) {
  return t;
}

function genarray_of_array1(t) {
  return t;
}

function genarray_of_array2(t) {
  return t;
}

function genarray_of_array3(t) {
  return t;
}

function array0_of_genarray(t) {
  var match = Ndarray.dimension(t);

  if (match !== 0) {
    throw [Caml_builtin_exceptions.invalid_argument, "not a 0 dimensional bigarray"];
  }

  return t;
}

function array1_of_genarray(t) {
  var match = Ndarray.dimension(t);

  if (match !== 1) {
    throw [Caml_builtin_exceptions.invalid_argument, "not a 1 dimensional bigarray"];
  }

  return t;
}

function array2_of_genarray(t) {
  var match = Ndarray.dimension(t);

  if (match !== 2) {
    throw [Caml_builtin_exceptions.invalid_argument, "not a 2 dimensional bigarray"];
  }

  return t;
}

function array3_of_genarray(t) {
  var match = Ndarray.dimension(t);

  if (match !== 3) {
    throw [Caml_builtin_exceptions.invalid_argument, "not a 3 dimensional bigarray"];
  }

  return t;
}

function reshape(param) {
  return Pervasives.failwith("Bigarray_bs.reshape: unsupported");
}

function reshape_0(param) {
  return Pervasives.failwith("Bigarray_bs.reshape_0: unsupported");
}

function reshape_1(param) {
  return Pervasives.failwith("Bigarray_bs.reshape_1: unsupported");
}

function reshape_2(param) {
  return Pervasives.failwith("Bigarray_bs.reshape_2: unsupported");
}

function reshape_3(param) {
  return Pervasives.failwith("Bigarray_bs.reshape_3: unsupported");
}

var float32 =
/* Float32 */
0;
var float64 =
/* Float64 */
1;
var complex32 =
/* Complex32 */
10;
var complex64 =
/* Complex64 */
11;
var int8_signed =
/* Int8_signed */
2;
var int8_unsigned =
/* Int8_unsigned */
3;
var int16_signed =
/* Int16_signed */
4;
var int16_unsigned =
/* Int16_unsigned */
5;
var $$int =
/* Int */
8;
var int32 =
/* Int32 */
6;
var int64 =
/* Int64 */
7;
var nativeint =
/* Nativeint */
9;
var $$char =
/* Char */
12;
var c_layout =
/* C_layout */
0;
var fortran_layout =
/* Fortran_layout */
1;
var Genarray = {
  create: create,
  num_dims: Ndarray.dimension,
  dims: Ndarray.shape,
  nth_dim: nth_dim,
  kind: Ndarray.kind,
  layout: layout,
  change_layout: change_layout,
  size_in_bytes: size_in_bytes,
  get: Ndarray.get,
  set: Ndarray.set,
  sub_left: sub_left,
  sub_right: sub_right,
  slice_left: Ndarray.pick,
  slice_right: slice_right,
  blit: blit,
  fill: fill,
  fold: fold,
  iter: iter,
  map_file: map_file,
  read_t: read_t,
  write_t: write_t,
  fromJs: Ndarray.fromJs,
  toJs: Ndarray.toJs
};
var Array0 = {
  create: create$1,
  kind: Ndarray.kind,
  layout: layout,
  change_layout: change_layout,
  size_in_bytes: size_in_bytes,
  get: get,
  set: set,
  blit: blit,
  fill: fill,
  of_value: of_value
};
var Array1 = {
  create: create$2,
  dim: dim,
  kind: Ndarray.kind,
  layout: layout,
  change_layout: change_layout,
  size_in_bytes: size_in_bytes,
  get: get$1,
  set: set$1,
  sub: sub_left,
  slice: slice,
  blit: blit,
  fill: fill,
  of_array: of_array,
  map_file: map_file$1,
  unsafe_get: get$1,
  unsafe_set: set$1
};
var Array2 = {
  create: create$3,
  dim1: dim1,
  dim2: dim2,
  kind: Ndarray.kind,
  layout: layout,
  change_layout: change_layout,
  size_in_bytes: size_in_bytes,
  get: get$2,
  set: set$2,
  sub_left: sub_left,
  sub_right: sub_right,
  slice_left: slice_left,
  slice_right: slice_right$1,
  blit: blit,
  fill: fill,
  of_array: of_array$1,
  map_file: map_file$2,
  unsafe_get: get$2,
  unsafe_set: set$2
};
var Array3 = {
  create: create$4,
  dim1: dim1$1,
  dim2: dim2$1,
  dim3: dim3,
  kind: Ndarray.kind,
  layout: layout,
  change_layout: change_layout,
  size_in_bytes: size_in_bytes,
  get: get$3,
  set: set$3,
  sub_left: sub_left,
  sub_right: sub_right,
  slice_left_1: slice_left_1,
  slice_right_1: slice_right_1,
  slice_left_2: slice_left_2,
  slice_right_2: slice_right_2,
  blit: blit,
  fill: fill,
  of_array: of_array$2,
  map_file: map_file$3,
  unsafe_get: get$3,
  unsafe_set: set$3
};
export { float32, float64, complex32, complex64, int8_signed, int8_unsigned, int16_signed, int16_unsigned, $$int, int32, int64, nativeint, $$char, kind_size_in_bytes, c_layout, fortran_layout, Genarray, Array0, Array1, Array2, Array3, genarray_of_array0, genarray_of_array1, genarray_of_array2, genarray_of_array3, array0_of_genarray, array1_of_genarray, array2_of_genarray, array3_of_genarray, reshape, reshape_0, reshape_1, reshape_2, reshape_3 };
/* Ndarray Not a pure module */